import MeasurementLines from "../../MeasurementLines";

export const WeldacMeasurementLines = ({ node }) => {
  return <MeasurementLines node={node} radius={0.005} sidesLength={0.05} fontSize={0.075} color={"#ffffff"} />;
};
